<template>
  <div class="reverseInvoiceList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="invoiceApplication/selectToDoInvoiceWithPage"
        @select="selectHandle"
        @select-all="selectHandle">
      >
      <template slot="adSearch">
        <vm-search label="发货单号">
          <el-input v-model="filter.invoiceNo" clearable type="textarea" autosize/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model="filter.factoryNo" clearable type="textarea" autosize/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model="filter.purchaseUnit" clearable/>
        </vm-search>
        <vm-search label="项目名称">
          <el-input v-model="filter.projectName" clearable/>
        </vm-search>
        <vm-search label="客户合同号">
          <el-input v-model="filter.clientContractNO" clearable/>
        </vm-search>
        <vm-search label="能否开票">
          <el-select v-model="filter.availableInvoice" clearable>
            <el-option label="可开票" :value="'可开票'"/>
            <el-option label="不可开票" :value="'不可开票'"/>
          </el-select>
        </vm-search>
        <vm-search label="发运状态">
          <el-select v-model="filter.completeEndState" clearable>
            <el-option label="未发运" :value="'未发运'"/>
            <el-option label="已发运" :value="'已发运'"/>
          </el-select>
        </vm-search>
        <vm-search label="过账状态">
          <el-select v-model="filter.postingStatus" clearable>
            <el-option label="未过账" :value="'A'"/>
            <el-option label="已过账" :value="'C'"/>
          </el-select>
        </vm-search>
        <vm-search label="签收状态">
          <el-select v-model="filter.invoiceReceiveStatus" clearable>
            <el-option label="未签收" :value="'未签收'"/>
            <el-option label="已签收" :value="'已签收'"/>
          </el-select>
        </vm-search>
      </template>
      <div slot="toolbar">
        <el-button type="primary" :disabled="!selection.length" @click="handle()">
          开票申请
        </el-button>
        <el-button type="primary" @click="buyListDownLoadFile">
          导出
        </el-button>
        <el-button icon="el-icon-download" type="primary" plain @click="downloadExcel()">操作说明</el-button>
      </div>
      <el-table-column type="selection" align="center" width="55" fixed="left"/>
      <el-table-column align="center" prop="availableInvoice" label="能否开票" width="85">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.availableInvoice==='可开票'" type="success">可开票</el-tag>
          <el-tag v-if="scope.row.availableInvoice==='不可开票'" type="danger">不可开票</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="factoryNo" label="出厂编号" width="100"/>
      <el-table-column align="center" prop="invoiceNo" label="发货单" width="80"/>
      <el-table-column align="center" prop="completeEndState" label="发运状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.completeEndState==='已发运'" type="success">已发运</el-tag>
          <el-tag v-if="scope.row.completeEndState==='未发运'" type="danger">未发运</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="completeEndDate" label="发运时间" width="140"/>
      <el-table-column align="center" prop="postingStatus" label="过账状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.postingStatus==='已过账'" type="success">已过账</el-tag>
          <el-tag v-if="scope.row.postingStatus==='未过账'" type="danger">未过账</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="postingTime" label="过账时间" width="140"/>
      <el-table-column align="center" prop="invoiceReceiveDesc" label="签收状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.invoiceReceiveDesc==='已签收'" type="success">已签收</el-tag>
          <el-tag v-if="scope.row.invoiceReceiveDesc==='未签收'" type="danger">未签收</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceReceiveDate" label="签收时间" width="140"/>
      <el-table-column align="center" prop="totalMoney" label="EMES订单金额" width="120"/>
      <el-table-column align="center" prop="totalAmount" label="SAP订单金额" width="120">
        <template slot-scope="scope">
          <el-tag v-if="parseFloat(scope.row.totalMoney)===parseFloat(scope.row.totalAmount)" type="success">
            {{scope.row.totalAmount}}
          </el-tag>
          <el-tag v-else type="danger">{{scope.row.totalAmount}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="harvestUnits" label="客户名称" width="250"/>
      <el-table-column
          align="center"
          prop="projectName"
          label="项目名称"
          width="250"
          show-overflow-tooltip/>
      <el-table-column
          align="center"
          prop="clientContractNO"
          label="客户合同号"
          width="250"
          show-overflow-tooltip/>
      <el-table-column align="center" prop="employeeName" label="创建人"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "ToDoInvoiceList",
    components: {VmTable, VmSearch},
    data() {
      return {
        selection: [],
        filter: {
          factoryNo: "",
          invoiceNo: "",
          purchaseUnit: "",
          projectName: "",
          clientContractNO: "",
          postingStatus: "",
          completeEndState: "",
          invoiceReceiveStatus: "",
          availableInvoice: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      handle() {
        const status = this.selection.filter(item => item.availableInvoice === "不可开票").length;
        const customer = this.selection.every(item => item.harvestUnits === this.selection[0].harvestUnits);
        if (!customer) {
          this.$confirm("客户名称不一致,请重新选择", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else if (status) {
          this.$confirm("存在不可开票发货单,请重新选择", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$router.push({
            path: "/InvoiceApplicationPreview",
            query: {
              billId: 0,
              $tabName: "开票申请",
              selection: this.selection,
            },
          });

        }

      },


      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
          .exportFile("basic", "invoiceApplication/exportToDoInvoice", this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },

      //下载说明
      downloadExcel() {
        window.open("/publicFile/开票管理操作步骤说明.docx");
      },
    },
  };
</script>
<style lang="scss">
</style>
